import { useCallback } from 'react';
import {
  trackEvent as trackAmplitudeEvent,
  identifyUser as identifyAmplitudeUser,
  resetUser as resetAmplitudeUser,
  UserProperties,
} from '@/lib/analytics/amplitude';

export const useAnalytics = () => {
  const trackEvent = useCallback((eventName: string, eventProperties?: Record<string, unknown>) => {
    trackAmplitudeEvent(eventName, eventProperties);
  }, []);

  const identifyUser = useCallback((userId: string, userProperties?: UserProperties) => {
    identifyAmplitudeUser(userId, userProperties);
  }, []);

  const resetUser = useCallback(() => {
    resetAmplitudeUser();
  }, []);

  return { trackEvent, identifyUser, resetUser };
};
